'use strict';

const CONTROL_EVENT_PREFIX = 'gold-file:';
module.exports =  function GoldFileHistoryEvent(sessionIdRetriever) {
	if (!sessionIdRetriever) {
		throw new Error('invalid-args');
	}
	const self = this;
	self.isNonControlEvent = (evt) => {
		return evt && evt.cmd && !evt.cmd.startsWith(CONTROL_EVENT_PREFIX);
	};
	self.isRenameEvent = (evt) => {
		return evt && evt.cmd && evt.cmd.startsWith(CONTROL_EVENT_PREFIX + 'rename');
	};
	self.isTrashedEvent = (evt) => {
		return evt && evt.cmd && evt.cmd.startsWith(CONTROL_EVENT_PREFIX + 'trashed');
	};
	self.hasRemoteEvents = (envelope) => {
		const sessionId = envelope && envelope.header && envelope.header.sessionId;
		return (sessionId !== sessionIdRetriever());
	};
	self.buildLocalControlEvent = (type, args) => {
		return {cmd: CONTROL_EVENT_PREFIX + type, args: args};
	};
};
